import { config } from '@terminal/config';
import {
  deleteNotionDisconnect,
  postNotionConnect,
} from '@terminal/services/alfred-intergations/alfred-integrations-service';
import { useOAuthPkceConnect } from './useOAuthPkceConnect';

export const isValidNotionServiceName = (
  serviceName?: string
): serviceName is 'notion' => serviceName === 'notion';

interface UseNotionConnectProps {
  refetchServices: () => void;
}

export const useNotionConnect = ({
  refetchServices,
}: UseNotionConnectProps) => {
  const { connect, disconnect } = useOAuthPkceConnect({
    serviceName: 'notion',
    displayName: 'Notion',
    redirectUri: config.notion.redirectUri,
    buildAuthorizeUrl: ({ state, codeChallenge }) => {
      const authParams = new URLSearchParams({
        client_id: config.notion.clientId,
        response_type: 'code',
        redirect_uri: config.notion.redirectUri,
        scope: 'default',
        state,
        code_challenge: codeChallenge,
        code_challenge_method: 'S256',
        resource: config.notion.issuer,
      });

      return `${config.notion.authorizeUrl}?${authParams}`;
    },
    postConnect: postNotionConnect,
    deleteDisconnect: deleteNotionDisconnect,
    refetchServices,
  });

  return { connectNotion: connect, disconnectNotion: disconnect };
};
